import clsx from 'clsx';
import React from 'react';

const HeadingItem = ({ children, className, ...props }) => {
  return (
    <span
      className={clsx(
        'text-sm font-semibold text-gray-400 uppercase tracking-wide',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export default HeadingItem;
